var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscountTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.9 6.403a2.483 2.483 0 1 1-3.512 3.512A2.483 2.483 0 0 1 9.9 6.403m-.849.848a1.283 1.283 0 1 1-1.815 1.815 1.283 1.283 0 0 1 1.815-1.815",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.594 17.626a3.99 3.99 0 0 1-1.161-3.064l.484-7.908a3.99 3.99 0 0 1 3.738-3.737l7.907-.484a3.99 3.99 0 0 1 3.065 1.16l10.78 10.78a3.99 3.99 0 0 1 0 5.642l-8.392 8.392a3.99 3.99 0 0 1-5.641 0zM16.778 4.442l10.78 10.78a2.79 2.79 0 0 1 0 3.944l-8.391 8.392a2.79 2.79 0 0 1-3.945 0l-10.78-10.78a2.8 2.8 0 0 1-.811-2.143l.484-7.907a2.79 2.79 0 0 1 2.613-2.614l7.908-.484a2.79 2.79 0 0 1 2.142.812",
  clipRule: "evenodd"
})));
export { SvgDiscountTag as ReactComponent };